module.exports = __webpack_public_path__ + "img/Scratch.64e70ef1.png";